<ngx-spinner
	bdColor="rgba(75, 55, 100, 0.5)"
	size="large"
	color="#fff"
	type="line-scale-pulse-out">
	<span class="chevron left"></span>
	<span class="chevron right"></span>
</ngx-spinner>
<div class="m-grid__item m-grid__item--fluid m-wrapper">
	<div class="m-content">
		<!--begin::Portlet-->
		<!--begin::Form-->
		<form
			[formGroup]="form"
			*ngIf="form"
			class="m-form m-form--fit m-form--label-align-right">

				<div class="m-portlet">
		
					<div class="m-portlet__head">
						<div class="m-portlet__head-caption">
							<div class="m-portlet__head-title">
								<h3 class="m-portlet__head-text">
									BARREL PRINTER INFORMATION
								</h3>
							</div>
						</div>
					</div>
		
					<div class="m-portlet__body">
						<div class="m-form__section m-form__section--first">

					<div class="form-group m-form__group row">
						<label class="col-lg-4 col-form-label">
						Printer Name:
						</label>
						<div class="col-lg-3">
							<input
								formControlName="name"
								type="text"
								id="name"
								class="form-control m-input"
								placeholder=""
								/>
							<app-validation-display
								[control]="form.controls.name"
								errorMessage="Please provide a name for this printer"
								></app-validation-display>
						</div>
					</div>
                    <div class="form-group m-form__group row">
                        <label class="col-lg-4 col-form-label">
                            Assigned Event
                        </label>
                        <div class="col-lg-3">
                            <select
                                style="width: 200px; color: black; height: 37px; margin-left: 5px; display: inline;"
                                id="cue5050Id"
                                class="form-control m-input"
                                formControlName="cue5050Id"
                                name="cue5050Id">
                            <option 												      
                                [ngValue]="0">
                                -- Reset Selection --
                            </option>
                            <option *ngFor="let event of events" 													      
                                [ngValue]="event.cue5050Id">
                                {{event.event.name}}
                            </option>
                            
                            </select>
                        </div>
                    </div>

					</div>
				</div>	

			</div>	
        </form>

        <div class="form-group m-form__group row">
			<div class="col-lg-12">
				<button type="submit" (click)="save()" class="btn btn-primary">
				{{ printerId ? "Update" : "Create" }}
				</button>
				<button style="margin-left: 15px;" type="submit" (click)="navigateUp()" class="btn btn-danger">
				Cancel
				</button>
				<div *ngIf="hasErrors()">
					<span style="color:red">Please complete the required fields</span>
				</div>
			</div>
		</div>
    </div>
</div>